export const MESSAGE_SOURCE = {
  /** Inbound message from a customer (end user) */
  CUSTOMER: 'CUSTOMER',
  /** Outbound message typed by a human operator/adjuster */
  OPERATOR: 'OPERATOR',
  /** Automated reply sent on behalf of an operator (OOO, away, inactivity) */
  OPERATOR_AUTO_REPLY: 'OPERATOR_AUTO_REPLY',
  /** System-generated outbound message (welcome, opt-in, chatbot, templates) */
  SYSTEM: 'SYSTEM',
  /** Grey event message from internal system actions (opt-in/out, survey, assignment, etc.) */
  SYSTEM_EVENT: 'SYSTEM_EVENT',
  /** Outbound SMS message triggered by a partner integration (Copart, Verisk, etc.) */
  PARTNER_MESSAGE: 'PARTNER_MESSAGE',
  /** Grey event message from a partner integration */
  PARTNER_EVENT: 'PARTNER_EVENT',
  /** Outbound message generated by an AI agent (Fabric) */
  AI_AGENT: 'AI_AGENT',
  /** Grey event message for AI agent lifecycle (started, completed, paused, etc.) */
  AI_AGENT_EVENT: 'AI_AGENT_EVENT',
} as const;

export type MessageSource =
  (typeof MESSAGE_SOURCE)[keyof typeof MESSAGE_SOURCE];

export const EVENT_TYPE = {
  COPART_GRAY: 'copart-gray-event',
  XACT_ANALYSIS_GRAY: 'xact-analysis-gray-event',
  PARTNER_GRAY: 'partner-gray-event',
  SURVEY_PREFIX: 'survey',
  CASE_ADDRESSED_AI: 'case-addressed-ai-event',
  CASE_MEMO: 'case-memo',
} as const;

export type EventType = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];

export const IGNORED_INTERNAL_SOURCES: readonly string[] = [
  MESSAGE_SOURCE.OPERATOR,
  MESSAGE_SOURCE.OPERATOR_AUTO_REPLY,
];
